import React, { useEffect, useRef, useCallback } from "react";
import { toast } from "react-toastify";

function Paypal(props) {
  const paypal = useRef();
  const { price, getPaypalDetail } = props;

  const handlePaypalSuccess = useCallback(
    async (data, actions) => {
      try {
        const order = await actions.order.capture();
        getPaypalDetail(order);
      } catch (error) {
        console.error('PayPal capture failed:', error);
        toast.error("Payment capture failed. Please contact support.");
      }
    },
    [getPaypalDetail]
  );

  const handleCreateOrder = useCallback(
    (data, actions) => {
      return actions.order.create({
        intent: "CAPTURE",
        purchase_units: [
          {
            description: "License Fee",
            amount: {
              currency_code: "USD",
              value: price,
            },
          },
        ],
      });
    },
    [price]
  );

  const handleError = useCallback((err) => {
    console.error('PayPal error:', err);
    toast.error("Payment failed. Please try again.");
  }, []);

  useEffect(() => {
    const renderPayPalButtons = () => {
      if (window.paypal && paypal.current) {
        paypal.current.innerHTML = "";
        
        window.paypal
          .Buttons({
            createOrder: handleCreateOrder,
            onApprove: handlePaypalSuccess,
            onError: handleError,
          })
          .render(paypal.current);
      }
    };

    const addPayPalScript = () => {
      const script = document.createElement("script");
      script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&disable-funding=credit,card&vault=true`;
      script.id = "paypal-script";
      script.async = true;
      script.onload = () => {
        renderPayPalButtons();
      };
      document.body.appendChild(script);
    };

    const existingScript = document.getElementById("paypal-script");
    if (!existingScript) {
      addPayPalScript();
    } else {
      renderPayPalButtons();
    }

    return () => {
      if (paypal.current) {
        paypal.current.innerHTML = "";
      }
    };
  }, [price, handleCreateOrder, handlePaypalSuccess, handleError]);

  return <div ref={paypal}></div>;
}

export default Paypal;
